//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineCancelCauseLang', {
//        templateUrl: 'views/components/views/orderLineCancelCauseLang/orderLineCancelCauseLang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'orderLineCancelCauseLangService', function ($stateParams, stateService, orderLineCancelCauseLangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderLineCancelCauseKeyno = $stateParams.orderlinecancelcause_keyno;
            
//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await orderLineCancelCauseLangService.listOrderLineCancelCauseLanguages({ orderlinecancelcause_keyno: orderLineCancelCauseKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                orderLineCancelCauseLangService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
